import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@infodata-group/inf-commons';

@Injectable({
  providedIn: 'root',
})
export class DayNotWorkService {
  private readonly settings = inject(SettingsService);

  public readonly dayNotWorkColor = '#EEE';

  public days: {
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
  } = {
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: false,
    sunday: false,
  };

  private readonly WEEK = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];

  public isDayWork(date: Date) {
    const day = date.getDay();
    return this.days[this.WEEK[day]];
  }

  public getDaysNotWork() {
    const userPreferences = this.settings.getSetting('userPreferences');
    if (userPreferences && userPreferences.workingWeek) {
      for (const day in this.days) {
        this.days[day] = userPreferences.workingWeek[day] ?? false;
      }
    } else {
      this.days = {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: false,
        sunday: false,
      };
    }
  }
}
